import loginPageIconImport from "../assets/login.svg";
import registerPageIconImport from "../assets/register.svg";

export const adminPath = "adel-ahmed-admin-panel";
export const domainName = "mr-ahmed-adel.com";
export const teachersubadminPath = "ayman-teacher-admin";

export const isManualPayment = false;
export const isCouponable = true;
export const isMultiYear = false;
export const isCodes = true;
export const isBtns = false;
export const isLoginTokens = true;
export const profileStatistics = true;

export const enableAutoLogin = false;

export const isFreeTrialAvailable = false;

export const adminPanelColor = "stone";
export const headerSectionColor = "stone";
export const navbarIconColor = "text-yellow-500";
export const navbarDisclosureColor = "yellow";

export const progressBarColor = "yellow";
export const loadingBarColor = "yellow";

export const isBunny = false;

export const isKillerPlayer = true;

export const isPlatformSubscription = false;
export const isTimedManualSubscription = false;

export const isPrepaidSystem = true;
export const prepaidInfoColor = "yellow";

export const autoChangeRandomNames = true;
export const autoChangeCenterWithNames = true;
export const autoChangeDataWithNames = true;

export const navThemeRTL = true;

export const registerPageIcon = registerPageIconImport;
export const loginPageIcon = loginPageIconImport;
export const loginPageColor = "yellow";
export const registerPageColor = "stone";

export const isAnalytics = false;
export const isAbleChangingPassword = false;

export const isMultiAdmin = true;

export const isAccountCreationRequest = false;

export const isCategories = true;
export const isCollapseCategories = false;

export const showExamStatisticsTable = true;
export const showVideoStatisticsTable = true;

export const isSubjectSubscriptionable = false;

export const isOtpEnabled = false;

export const isWalletEnabled = true;
export const isManualChargeWallet = true;

export const isHideNavbarFromAdminPanel = false;

export const isOnlySubscribeFromWallet = false;

export const isCenterUsers = false;

export const isForgetPassword = false;

export const isAdminUsers = false;

export const isSubscribeBySubjectTeacher = false;

export const isMigrationFromInsertAuto = false;
export const isChargeInsertAuto = true;
export const isInsertAutoTypes = true;

export const isCourseRenamedToMonthlySubscriptions = false;

export const isCommunity = false;

export const isCustomUserExamLimit = true;
export const isCustomUserVideoLimit = true;

export const isCenterApi = true;

export const isGlobalNotifications = true;
